import { useCallback, useState } from 'react';

const useRead = () => {
  const [isRead, setIsRead] = useState(true);
  const handleClickUnread = useCallback(() => {
    setIsRead(false);
  }, []);
  const handleClickAll = useCallback(() => {
    setIsRead(true);
  }, []);
  return {
    isRead,
    handleClickUnread,
    handleClickAll,
  };
};
export default useRead;
